import ButtonsField from "./buttons-field";
import Select from "../select";
import FormField from "../form-field";
import Api from "../../../../lib/api";

export default class ConsultationField extends FormField {
	constructor(props) {
		super(props);

		this.$consultationTime = null;

		this.timeSelect = null;
		this.optionsData = [{
			label: craft.localization.fitsAnyTime,
			value: null
		}];

		this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT = 'timeSelectToggleVisibility';

		this.init();
	}

	init() {
		this.$consultationTime = this.$root.querySelector('[data-type="consultation-time"]');
		const $buttonsField = this.$root.querySelector('[data-type="buttons"]');

		if ($buttonsField) {
			this.switch = new ButtonsField({
				$root: $buttonsField,
				name: 'getConsultation'
			});
		}

		this.timeSelect = new Select({
			$root: this.$root.querySelector('.listbox'),
			name: 'consultationTime'
		});

		this.bootstrap();

		super.init();
	}

	bootstrap() {
		Api.get(`${Api.restSiteUrl}/1.0/helper/consultation-time`, {
			lang: document.querySelector('html').lang,
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
		}).then((optionList) => {
			if (optionList.length) {
				this.optionsData.push(...optionList);
				this.initTimeSelect();
			}

			this.toggleFieldVisibility(!!optionList.length);
		});
	}

	addEventListeners() {
		if (this.switch) {
			this.switch.subscribe('valueChange', (e) => {
				this.toggleTimeSelectVisibility();
				this.setValue(e.detail);
				this.validateSoft();
			});
		}

		super.addEventListeners();
	}

	validate() {
		if (this.switch) {
			this.switch.validate();
			this.isValid = this.switch.isValid;
		} else {
			this.isValid = true;
		}
	}

	initTimeSelect() {
		this.timeSelect.addOptions(this.optionsData);
		this.timeSelect.selectFirstOption();
	}

	toggleFieldVisibility(shouldShow) {
		if (!this.switch) {
			if (shouldShow) {
				this.$root.classList.remove('-hidden');
				this.$consultationTime.classList.remove('-hidden');
				this.dispatchEvent(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, true);
			} else {
				this.$root.classList.add('-hidden');
				this.dispatchEvent(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, false);
			}
		} else {
			this.toggleTimeSelectVisibility();
		}
	}

	toggleTimeSelectVisibility(shouldShow) {
		if (shouldShow && this.switch.value) {
			this.$consultationTime.classList.remove('-hidden');
			this.dispatchEvent(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, true);
		} else {
			this.$consultationTime.classList.add('-hidden');
			this.dispatchEvent(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, false);
		}
	}

	getData() {
		if (!this.timeSelect.value || (this.switch && !this.value)) {
			return null;
		}

		return { [this.timeSelect.name]: +this.timeSelect.value };
	}

	setInitialState() {
		if (this.switch) {
			this.switch.setInitialState();
		}
	}
}